export enum ProductStatus {
  PUBLISHED = '40-GEPUB',
  NOT_PUBLISHED = '45-NI-GE',
  END_OF_LIFE_PRODUCT = '50-EOL',
  END_OF_LIFE_LINE = '99-EOL',
  FREE = '10-VRIJ'
}

export interface GetProductsResponse extends Omit<ApiResponse, 'results'> {
  results: Product[];
}

export interface ApiResponse {
  count?: number;
  total?: number;
  timing?: Timing;
  pagination?: ApiPagination;
  active?: any[];
  facets?: Facet[];
  sort?: SortItem[];
  options?: Options;
  results?: ApiProduct[];
  categories?: Category[];
  correctedAttributes?: boolean;
}

export interface ApiProduct {
  attributes?: { [key: string]: ApiAttribute };
  categories?: number[];
  code: string;
  dateImported?: Date;
  defaultVariantCode: string;
  description: string;
  displayOrder?: number;
  displayOrders?: { [key: string]: number };
  files?: File[];
  labels?: any[];
  mainCategoryId?: number;
  relatedProducts?: string[];
  sectors?: AppSector[];
  status: string;
  storeViews?: string[];
  symbols?: ApiProductSymbol[];
  title: string;
  url?: string;
  variantOptions: ApiAttribute[];
  variants: Variant[];
  videos?: any[];
  visible?: boolean;
}

export interface ApiVariant {
  productCode: string;
  code: string;
  imageName?: string;
  lineSequence?: number;
  media: Image[];
  optionCode1?: string;
  optionCode2?: string;
  status?: string;
  title: string;
  unitsOfMeasure: UnitOfMeasure[];
  url: string;
  visible?: boolean;
}

export interface VariantAttributeValue {
  code: string;
  disabled?: boolean;
  image?: string;
  url?: string;
  value: string;
}

export interface SelectableVariantAttribute {
  code: string;
  name: string;
  type: string;
  values: VariantAttributeValue[];
}

export interface UniqueSellingPoint {
  code: string;
  value: string;
}

export interface Product extends Omit<ApiProduct, 'variants' | 'variantOptions' | 'symbols'> {
  selectableVariantAttributes: SelectableVariantAttribute[];
  variants: Variant[];
  symbols?: ProductSymbol[];
  uniqueSellingPoints?: UniqueSellingPoint[];
  technicalData: TechnicalData[];
}

export interface URLSet {
  web: string;
  api: string;
  canonical?: string;
  rel?: string;
  noIndex?: boolean;
  invalid?: boolean;
}

export interface TypeClass {
  code: string;
  value: string;
  displayOrder: number;
}

export interface Options {
  skip?: number;
  take?: number;
  searchTerm?: string;
  sortBy?: string;
  includeHiddenLines?: boolean;
  visible?: boolean;
  status?: string[];
  context?: number;
  webPrefix?: string;
  includeContent?: boolean;
}

export type FacetsDictionary = { [key: string]: string[] }[];

export interface ApiAttribute {
  type: TypeClass;
  items: ApiProductSymbol[];
}

export interface ApiProductSymbol {
  code: TypeClass;
  value: TypeClass;
  url: string;
  images: Image[];
  image?: string;
}

export interface ProductSymbol {
  code: string;
  image: string;
  url: string;
  value: string;
}

export interface TechnicalData {
  code: string;
  image?: string;
  name: string;
  value: string;
}
export interface Image {
  type: string;
  src: string;
  modified?: Date;
  imageData?: ImageData;
}

export interface ImageData {
  width: number;
  height: number;
}

export interface File {
  type?: string;
  description?: string;
  src?: string;
  modified?: Date;
  languageCode?: string;
  fileTypeCode?: string;
}

export interface Attribute {
  code: string;
  value: string;
  url?: string;
  image?: string;
}

export type VariantAttributes = Record<string, string>;
export interface Variant extends Omit<ApiVariant, 'optionCode1' | 'optionCode2'> {
  variantAttributes: VariantAttributes;
}

export interface UnitOfMeasure {
  code: string;
  description: string;
  eanCode: string;
  itemsPerUnit: number;
  name: string;
  prices: Prices;
  unuom?: string;
  visible?: boolean;
}

export interface Prices {
  variantCode: string;
  unitOfMeasureCode: string;
  current: Current;
  old: Current;
  discount?: number;
  quantityPer?: number;
}

export interface Current {
  exTax: Tax;
  incTax: Tax;
}

export interface Tax {
  numeric: number;
  formatted: string;
}

export interface Media {
  type?: string;
  thumbnail?: string;
  description?: string;
  src: string;
  modified?: Date;
  languageCode?: string;
  alt?: string;
  imageData?: {
    height: number;
    width: number;
  };
}

export interface Prices {
  variantCode: string;
  unitOfMeasureCode: string;
  current: Current;
  old: Current;
  discount?: number;
  quantityPer?: number;
}

export interface Current {
  exTax: Tax;
  incTax: Tax;
}

export interface Tax {
  numeric: number;
  formatted: string;
}

export interface SortItem {
  code: string;
  value: string;
  urlSet: URLSet;
  selected?: boolean;
}

export interface Timing {
  'Solr.Prepare'?: number;
  'Solr.Query'?: number;
  'Process.Facets'?: number;
  'Process.Pagination'?: number;
  'Process.Sort'?: number;
  'Process.Results'?: number;
  Total?: number;
}

export interface Category {
  code: string;
  parentCode?: string;
  name: string;
  selected?: boolean;
  urlSet: URLSet;
  childCodes: string[];
  isRoot?: boolean;
}

export interface Facet {
  type: TypeClass;
  items: FacetItem[];
}

export interface FacetItem {
  value: TypeClass;
  hits: number;
  urlSet: URLSet;
  selected?: boolean;
}
